import { DropdownFilterButton } from '@finbeat/react-toolkit';
import { useServiceDiscountWorkplaceState } from './ServiceDiscount';
import { faPlus } from '@fortawesome/free-solid-svg-icons';

type ServiceDiscountAddButtonProps = {
    showModal: () => void;
};

const ServiceDiscountAddButton = ({ showModal }: ServiceDiscountAddButtonProps) => {
    const { setSelectedItem: setCurrentItem } = useServiceDiscountWorkplaceState();

    return (
        <DropdownFilterButton
            onClick={() => {
                setCurrentItem(null);
                showModal();
            }}
            icon={faPlus}
            disabled={false}
            title="BackOfficeAdd"
        />
    );
};

export default ServiceDiscountAddButton;
